import { ArrowRight, Mail } from "lucide-react";
import { Button } from "./ui/button";

export function CTA() {
	return (
		<section className="relative overflow-hidden py-24">
			<div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_center,_rgba(15,157,138,0.6),_rgba(6,48,44,0.95))]" />
			<div className="absolute inset-0 -z-10 bg-dotted-soft opacity-30" />
			<div className="absolute -top-32 left-1/2 -z-10 h-64 w-64 -translate-x-1/2 rounded-full bg-[radial-gradient(circle,_rgba(255,153,112,0.35),_transparent_70%)] blur-3xl" />
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="glass-panel relative mx-auto max-w-4xl space-y-8 rounded-[36px] border border-white/80 px-10 py-14 text-center text-foreground shadow-[0_50px_140px_-80px_rgba(5,48,44,0.7)]">
					<div className="mx-auto h-2 w-20 rounded-full bg-gradient-to-r from-[#ffc857] via-[#ff6b6b] to-[#4db9ff]" />
					<h2 className="text-4xl sm:text-5xl lg:text-6xl">
						Run a Developer Community on Discord?
					</h2>
					<p className="mx-auto max-w-2xl text-lg text-muted-foreground sm:text-xl">
						We want to help. Get early access to AI agents that automatically
						surface insights, and identify what your community needs, so you can
						focus on what matters.
					</p>

					<div className="flex flex-col items-center justify-center gap-4 pt-4 sm:flex-row">
						<Button
							size="lg"
							className="gap-2 rounded-full bg-primary px-8 py-6 text-base text-primary-foreground shadow-lg shadow-primary/30 hover:bg-primary/90 active:bg-primary/80"
							asChild
						>
							<a href="https://form.typeform.com/to/tnUCbmX4">
								<Mail className="h-5 w-5" />
								Early Access
								<ArrowRight className="h-4 w-4" />
							</a>
						</Button>
					</div>
				</div>
			</div>
		</section>
	);
}
